import React from "react";
import { PollTabStack } from "./PollTab.styles";
import { MainTextSection } from "./PollsTabSections/MainTextSection";
import { TextOptionsSection } from "./PollsTabSections/TextOptionsSection";
import { TimeLimitSection } from "./PollsTabSections/TimeLimitSection";
import { RateOptionsSection } from "./PollsTabSections/RateOptionsSection";
import { usePollOptionsState } from "./PollOptionsState";
import { PollTypesEnum } from "../../../../Shared/Types/Polls";
import { ImagesOptionsSection } from "./PollsTabSections/ImagesOptionsSection";
import { ChoosePollTypeSection } from "./PollsTabSections/ChoosePollTypeSection";
import { ResultVisibilityControlSection } from "./PollsTabSections/ResultVisibilityControlSection";

export function PollTab({
    setPostText,
    postText,
    allowPollEdit,
}: {
    allowPollEdit: boolean;
    postText: string;
    setPostText: (value: string) => void;
}) {
    return (
        <PollTabStack>
            <MainTextSection postText={postText} setPostText={setPostText} />
            <ChoosePollTypeSection allowPollEdit={allowPollEdit} />
            <OptionsSection
                allowPollEdit={allowPollEdit}
                postText={postText}
            />
            <ResultVisibilityControlSection />
            <TimeLimitSection />
        </PollTabStack>
    );
}

function OptionsSection({
    allowPollEdit,
    postText,
}: {
    allowPollEdit: boolean;
    postText?: string;
}) {
    const { pollType } = usePollOptionsState();

    switch (pollType) {
        case PollTypesEnum.POLL_VISIBLE:
        case PollTypesEnum.POLL_HIDDEN:
        case PollTypesEnum.POLL_QUIZ:
            return <TextOptionsSection allowPollEdit={allowPollEdit} />;
        case PollTypesEnum.POLL_RATING:
            return <RateOptionsSection content={postText} />;
        case PollTypesEnum.POLL_IMAGES:
            return <ImagesOptionsSection allowPollEdit={allowPollEdit} />;
        default:
            return null;
    }
}
